import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, CurrencyPipe } from '@angular/common';
import { InlineSVGModule } from 'ng-inline-svg';
import { PagesRoutingModule } from './pages-routing.module';
import {
  NgbDropdownModule,
  NgbModule,
  NgbNavModule,
  NgbProgressbarModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { TranslationModule } from '../modules/i18n/translation.module';
import { LayoutComponent } from './_layout/layout.component';
import { ScriptsInitComponent } from './_layout/init/scipts-init/scripts-init.component';
import { HeaderMobileComponent } from './_layout/components/header-mobile/header-mobile.component';
import { FooterComponent } from './_layout/components/footer/footer.component';
import { HeaderComponent } from './_layout/components/header/header.component';
import { HeaderMenuComponent } from './_layout/components/header/header-menu/header-menu.component';
import { TopbarComponent } from './_layout/components/topbar/topbar.component';
import { ExtrasModule } from '../_metronic/partials/layout/extras/extras.module';
import { LanguageSelectorComponent } from './_layout/components/topbar/language-selector/language-selector.component';
import { CoreModule } from '../_metronic/core';
import { SubheaderModule } from '../_metronic/partials/layout/subheader/subheader.module';
import { AsideDynamicComponent } from './_layout/components/aside-dynamic/aside-dynamic.component';
import { HeaderMenuDynamicComponent } from './_layout/components/header/header-menu-dynamic/header-menu-dynamic.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CRUDTableModule } from '../_metronic/shared/crud-table';
import { ListDocumentsComponent } from './list-documents/list-documents.component';
import { ListEstatementsComponent } from './list-estatements/list-estatements.component';
import { PaymentsComponent } from './payments/payments.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { HomepageComponent } from './homepage/homepage.component';
import { NgbDatepickerModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ListRequestComponent } from './list-request/list-request.component';
import { SafePipe } from './_pipes/safe/safe.pipe';
import { ListDocumentsFormsComponent } from './list-documents-forms/list-documents-forms.component';
import { ContactsComponent } from './contacts/contacts.component';
import { QuoteslifeComponent } from './quoteslife/quoteslife.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatRippleModule } from '@angular/material/core';
import { AngularFormsInputMasksModule } from 'angular-forms-input-masks';
import { ListClaimsComponent } from './list-claims/list-claims.component';
import { CreateClaimComponent } from './create-claim/create-claim.component';
import { NgxMaskModule } from 'ngx-mask';
import { UserDropdownInnerComponent } from '../_metronic/partials/layout/extras/dropdown-inner/user-dropdown-inner/user-dropdown-inner.component';
import { RequestComponent } from './request/request.component';
import { SendPolicyDocumentsComponent } from './send-policy-documents/send-policy-documents.component';
import { QuotesComponent } from './quotes/quotes.component';


@NgModule({
  declarations: [
    LayoutComponent,
    ScriptsInitComponent,
    HeaderMobileComponent,
    FooterComponent,
    HeaderComponent,
    HeaderMenuComponent,
    TopbarComponent,
    LanguageSelectorComponent,
    AsideDynamicComponent,
    HeaderMenuDynamicComponent,
    ListDocumentsComponent,
    ListEstatementsComponent,
    PaymentsComponent,
    MyProfileComponent,
    HomepageComponent,
    ListRequestComponent,
    SafePipe,
    ListDocumentsFormsComponent,
    ContactsComponent,
    QuoteslifeComponent,
    ListClaimsComponent,
    CreateClaimComponent,
    RequestComponent,
    SendPolicyDocumentsComponent,
    QuotesComponent,
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    TranslationModule,
    InlineSVGModule,
    ExtrasModule,
    NgbDropdownModule,
    NgbProgressbarModule,
    CoreModule,
    SubheaderModule,
    CRUDTableModule, // +
    FormsModule,
    ReactiveFormsModule,
    CarouselModule,
    NgbModalModule,
    MatFormFieldModule,
    NgbDatepickerModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatButtonModule,
    MatInputModule,
    MatRippleModule,
    NgbModule,
    NgbNavModule,
    NgbTooltipModule,
    AngularFormsInputMasksModule,
    NgxMaskModule.forRoot(),
  ],
  exports: [
    MatDatepickerModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatRippleModule,
  ]
})
export class LayoutModule { }
